import { animate, state, style, transition, trigger } from '@angular/animations';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Component, ElementRef, HostListener, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { ILocationDetails } from '../models/ILocationDetails';
import { IUserDetails } from '../models/IUsersDetails';
import { SchedularServiceService } from '../Services/Schedular/schedular-service.service';
import { SharedService } from '../Sharedservice/SharedService';
import { ONCCConfiguration, ONCCMasterMeasures } from '../models/IMasterAddedData';
import { ConfirmationDialogComponent } from '../ChildControls/confirmation-dialog/confirmation-dialog.component';
import { MatDialog } from '@angular/material';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { UserManagementService } from '../Services/UserManagement/user-management.service';
declare let $: any;

// export interface PeriodicElement {
//   provider: string;
//   location: string;
//   tin: string;
// }

@Component({
  selector: 'app-oncc-configuration',
  templateUrl: './oncc-configuration.component.html',
  styleUrls: ['./oncc-configuration.component.css'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})

export class OnccConfigurationComponent implements OnInit {
  ONCCConfigurationForm: FormGroup;
  columnsToDisplay = ['MeasureName', 'ProviderFullName', 'Action'];//, 'LocationNames', 'Tin'
  headercolumnsToDisplay = ['MeasureName', 'Provider', 'Action'];// 'Location', 'Tin',
  dataSource = new MatTableDataSource<ONCCConfiguration>();
  expandedElement: any | null;
  show: boolean = false;
  onccConfigList: ONCCConfiguration[] = [];
  lstProviders: IUserDetails[];
  lstworkListProviders: IUserDetails[];
  lstLocations: ILocationDetails[];
  public listMesureNames: ONCCMasterMeasures[];
  @ViewChildren('severityInput') severityInput: QueryList<ElementRef>;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  public isshowDrugReactionFocusEnabled: boolean = false;
  public SelectedDropDownListId: string = "";

  @HostListener("document:click", ['$event'])
  documentClickListner(event) {
    if (this.isshowDrugReactionFocusEnabled == false) {
      if (event.target.id.indexOf("ConfigLocFocus") > -1) {
        var countval = event.target.id.replace("ConfigLocFocus", "");
        var container = $("#reactionfocushideDrug" + countval);
        if (!container.is(event.target) && !container.has(event.target).length) {
          container.hide();
          this.SelectedDropDownListId = "";
        }
      }
      else if (event.currentTarget.activeElement != null && event.currentTarget.activeElement != undefined && event.currentTarget.activeElement.parentElement.id != undefined
        && event.currentTarget.activeElement.parentElement.id.indexOf("ConfigLocOptionId") > -1) {
        var countval = event.currentTarget.activeElement.parentElement.id.replace("ConfigLocOptionId", "");
        var container = $("#reactionfocushideDrug" + countval);
        if (!container.is(event.target) && !container.has(event.target).length) {
          container.show();
        }
      }
      else {
        this.SelectedDropDownListId = "";
        $(".reactionfocushideClass").hide();
      }
    }
    this.isshowDrugReactionFocusEnabled = false;
  }

  constructor(private sharedService: SharedService,
    private schedulerservice: SchedularServiceService,
    private userService: UserManagementService,
    private fb: FormBuilder,
    public dialog: MatDialog,
    private spinner: NgxSpinnerService,
    private toaster: ToastrService) { }

  ngOnInit() {
    $(document).click(function (event) {
      if (event.target.id != "ConfigLocFocus") {
        var container = $("#ConfigLocFocusHide");
        if (!container.is(event.target) && !container.has(event.target).length) {
          container.hide();
        }
      }

      if (event.target.id != "ReactionfocusUpdate") {
        var container = $("#UpdateReactionfocushide");
        if (!container.is(event.target) && !container.has(event.target).length) {
          container.hide();
        }
      }
      //**Food Allery reaction */
      if (event.target.id != "FoodReactionfocus") {
        var container = $("#FoodReactionfocushide");
        if (!container.is(event.target) && !container.has(event.target).length) {
          container.hide();
        }
      }

      if (event.target.id != "reactionfocusFood") {
        var container = $("#reactionfocushideFood");
        if (!container.is(event.target) && !container.has(event.target).length) {
          container.hide();
        }
      }
      //**Env Allery reaction */
      if (event.target.id != "EnvReactionfocus") {
        var container = $("#EnvReactionfocushide");
        if (!container.is(event.target) && !container.has(event.target).length) {
          container.hide();
        }
      }

      if (event.target.id != "reactionfocusFood") {
        var container = $("#reactionfocushideFood");
        if (!container.is(event.target) && !container.has(event.target).length) {
          container.hide();
        }
      }

    });

    this.ONCCConfigurationForm = this.fb.group({
      onccProvider: ['', Validators.required],
      onccLocation: ['-'],//, Validators.required],
      onccTin: ['0'],//, Validators.required],
      IsLocationCheck: [''],
      MeasureName: ['', Validators.required],
    });
    this.getProviders();
    this.getAllONCCConfigurations();
    this.getMeasureNames();
  }

  fnGetMeasurenameFromId(value, column) {
    if (column == 'MeasureName')
      return this.listMesureNames.filter(i => i.measureId == value)[0].measureName
    else
      return value;
  }
  getMeasureNames() {
    this.sharedService.getONCCMeasuresNameService(0, '').subscribe(data => {
      this.listMesureNames = data;
    });
  }

  showInfo() {
    this.expandedElement = null;
    this.ClearConfiguration();
    this.show = !this.show
  }

  getProviders() {
    // this.sharedService. getAllUsersByRoleWithOutLocId(Defaults.doctorType)
    this.userService.getAllUserswithLocations().subscribe(data => {
      this.lstProviders = data;
      // this.lstProviders.forEach(element => {
      //   element.fullName = element.UserAliasName ? element.UserAliasName : element.fullName;
      // });
    }, error => {
    });
  }

  providerCode: string = null;
  providerSelectionChanged(providerId) {
    /*
    this.ONCCConfigurationForm.patchValue({
      IsLocationCheck: false,
      onccLocation: ''
    });
    if (providerId != "") {
      this.getLocationsInfo(providerId, '', null)
    } else {
      this.lstLocations = [];
    }
*/
    this.ONCCConfigurationForm.controls["onccProvider"].setValue(providerId);
  }

  getLocationsInfo(providerId: any, type: string, ele: ONCCConfiguration) {
    this.lstLocations = [];
    this.schedulerservice.getLocationsByprovider(encodeURIComponent(providerId).toString()).subscribe(data => {
      this.lstLocations = data;
      this.lstLocations.forEach((ele: any) => {
        // ele.locationName = ele.locationAlias ? ele.locationAlias :
        //   ele.locationName
      })
      if (type == 'Edit') {
        var splitLoc = ele.LocationId.split(',');
        if (splitLoc.length > 0) {
          this.selectedList = [];
          this.lstLocations.filter(x => x.selected = splitLoc.includes(x.locationId.toString()));
          var selectobjs = this.lstLocations.filter(x => x.selected == true)
          if (selectobjs.length > 0) {
            this.selectedList = selectobjs;
            this.selectedlocactions = this.selectedList.filter(x => x.selected == true).map(y => y.locationId).join(',');
            this.locselected = this.selectedList.filter(x => x.selected == true).map(y => y.locationId).join(',');
            this.locanames = this.selectedList.filter(x => x.selected == true).map(y => y.locationName).join(',');
            this.locanames = this.locanames.substring(0, this.locanames.length - 2);
            this.locselected = this.locselected.substring(0, this.locanames.length - 1);
            this.ONCCConfigurationForm.patchValue({
              onccLocation: this.locanames,
            })
          } else {
            this.ONCCConfigurationForm.patchValue({
              onccLocation: ''
            })
          }
          this.checkDefaultLocation();
        }
      }
    });
  }

  getAllONCCConfigurations() {
    this.spinner.show();
    this.sharedService.getAllONCCConfiguration().subscribe(data => {
      this.onccConfigList = data;
      this.dataSource.data = this.onccConfigList;
      this.dataSource.paginator = this.paginator;
      this.spinner.hide();
    }, error => {
      this.spinner.hide();
    });
  }

  DeleteConfiguration(ele: ONCCConfiguration) {
    const dialogRef2 = this.dialog.open(ConfirmationDialogComponent, {
      width: '400px',
      height: '150px',
      data: { headerText: 'Do you want to delete this record?' }
    });

    dialogRef2.afterClosed().subscribe(dialogResult => {
      if (dialogResult == true) {
        this.spinner.show();
        this.sharedService.DeleteONCCConfiguration(ele.Id).subscribe(msg => {
          this.toaster.success(msg);
          this.getAllONCCConfigurations();
        }, error => {
          this.spinner.hide();
        });
      }
    });
  }

  public locanames: string = '';
  locselected: string = '';
  selectedList: ILocationDetails[] = [];
  selectedlocactions: string = '';
  checkSelectAllLocations(event, schstr) {
    if (event.target.checked) {
      this.selectedlocactions = '';
      this.locanames = '';
      this.locselected = '';
      this.selectedList = [];
      this.selectedList = this.lstLocations;
      this.selectedList.filter(x => x.selected = false);

      this.selectedlocactions = this.selectedList.map(x => x.locationId).join(',');
      this.locselected = this.selectedList.map(x => x.locationId).join(',');
      this.locanames = this.selectedList.map(x => x.locationName).join(',');
      this.selectedList.filter(x => x.selected = true);

      if (this.selectedList.length != 0) {
        this.locanames = this.locanames.substring(0, this.locanames.length - 2);
        this.locselected = this.locselected.substring(0, this.locanames.length - 1);
        this.ONCCConfigurationForm.patchValue({
          onccLocation: this.locanames,
        })
      }
      else {
        this.ONCCConfigurationForm.patchValue({
          onccLocation: ''
        })
      }
      this.ONCCConfigurationForm.patchValue({
        IsLocationCheck: true
      });

    } else {
      this.selectedlocactions = '';
      this.locanames = '';
      this.locselected = '';
      this.selectedList = [];
      this.lstLocations.forEach(x => x.selected = false);
      this.ONCCConfigurationForm.patchValue({
        onccLocation: '',
        IsLocationCheck: false
      });
    }
  }

  getlocationbasedproviders(onccLocRef) {
    this.selectedList = [];
    this.locselected = '';
    this.locanames = '';
    this.selectedlocactions = '';
    this.selectedList = onccLocRef.selectedOptions.selected.map(item => item.value);
    this.lstLocations.filter(x => x.selected = false);
    this.selectedList.forEach(element => {
      this.lstLocations.filter(x => x.locationId == element.locationId).map(y => y.selected = true)
    });

    this.selectedlocactions = this.selectedList.map(x => x.locationId).join(',');
    this.locselected = this.selectedList.map(x => x.locationId).join(',');
    this.locanames = this.selectedList.map(x => x.locationName).join(',');

    if (this.selectedList.length != 0) {
      this.locanames = this.locanames.substring(0, this.locanames.length - 2);
      this.locselected = this.locselected.substring(0, this.locanames.length - 1);
      this.ONCCConfigurationForm.patchValue({
        onccLocation: this.locanames,
      })
    }
    else {
      this.ONCCConfigurationForm.patchValue({
        onccLocation: ''
      })
    }
    this.checkDefaultLocation();
  }

  checkDefaultLocation() {
    if (this.selectedList.length > 0 && this.selectedList != undefined) {
      var selectProvlst = this.selectedList.filter(x => x.selected == true);
      if (selectProvlst.length === this.lstLocations.length) {
        this.ONCCConfigurationForm.patchValue({
          IsLocationCheck: true
        });
      } else {
        this.ONCCConfigurationForm.patchValue({
          IsLocationCheck: false
        });
      }
    } else {
      this.ONCCConfigurationForm.patchValue({
        IsLocationCheck: false
      });
    }
  }

  ClearConfiguration() {
    this.lstLocations = [];
    this.ONCCConfigurationForm.patchValue({
      onccProvider: '',
      onccLocation: '',
      onccTin: '',
      IsLocationCheck: false,
      MeasureName: ''
    });
  }

  ONCCConfig: ONCCConfiguration;
  saveConfiguration(element: ONCCConfiguration) {
    this.spinner.show();
    var Id = 0
    if (element != null) {
      Id = element.Id;
    }
    this.ONCCConfig = new ONCCConfiguration();
    this.ONCCConfig.Id = Id
    this.ONCCConfig.ProviderId = encodeURIComponent(this.ONCCConfigurationForm.value.onccProvider);
    this.ONCCConfig.LocationId = this.locselected;
    this.ONCCConfig.Tin = this.ONCCConfigurationForm.value.onccTin
    this.ONCCConfig.CreatedBy = encodeURIComponent(sessionStorage.getItem("userId")).toString();
    this.ONCCConfig.MeasureName = this.ONCCConfigurationForm.value.MeasureName;

    this.sharedService.SaveOrUpdateONCCConfiguration(this.ONCCConfig).subscribe(msg => {
      this.toaster.success(msg);
      this.show = false;
      this.getAllONCCConfigurations();
    }, error => {
      this.spinner.hide();
    });
  }

  IsDisabledddl: boolean = false;
  onEditClick(element: ONCCConfiguration) {
    this.show = false;
    //this.IsDisabledddl = true;
    this.ONCCConfigurationForm.patchValue({
      onccProvider: element.ProviderId,
      onccTin: element.Tin,
      MeasureName: element.MeasureName
    });
    this.getLocationsInfo(element.ProviderId, 'Edit', element);
  }

  onSelectionChanged(event) {
    setTimeout(() => {
      if (event !== null && event !== undefined) {
        $(event.target).prev().trigger('focus');
      }
    }, 100);
  }

  ConfigLocfocusOutFunction(evn) {
    if (evn.keyCode === 9) {
      $('#ConfigLocFocusHide').hide();
    } else if (evn.keyCode === 40 && evn.target.id == "ConfigLocFocus") {
      $('#reactionListIdDrug0').focus();
    }
  }

  ConfigLocFocus() {
    $('#ConfigLocFocusHide').show();
    $('.mat-selection-list').scrollTop(0);
  }

  ConfigLocFocusOutFn(evn, i) {
    if (evn.keyCode === 9) {
      $('#reactionfocushideDrug' + i).hide()
      this.SelectedDropDownListId = '';

      setTimeout(() => {
        (this.severityInput.toArray())[i].nativeElement.focus();
      }, 100);

    } else if (evn.keyCode === 40 && evn.target.id == "ConfigLocFocusId" + i) {
      $('#reationIdDrug0_' + i).focus();
    }
  }

  tabshowConfigFocus(i) {
    this.isshowDrugReactionFocusEnabled = true;
    $('#reactionfocushideDrug' + i).hide();
    this.SelectedDropDownListId = 'ConfigLocFocusId' + i.toString();
  }

  showConfigFocus(i) {
    $(".reactionfocushideClass").hide();
    this.isshowDrugReactionFocusEnabled = true;
    $('#reactionfocushideDrug' + i).show();
    this.SelectedDropDownListId = 'ConfigLocFocusId' + i.toString();
  }

  fnShowDropDownListAl1(i) {
    return this.SelectedDropDownListId == i.toString();
  }

  isReactionselected(rnaem, reactionObj) {
    if (reactionObj.locationId != '') {
      var obj = reactionObj.allergyReactions.filter(x => x.reactionName.toLowerCase() == rnaem.toLowerCase());
      return obj.length > 0
    }
  }
}
